// Getters
export const EPISODES = 'podcast/EPISODES'
export const CURRENT_EPISODE = 'podcast/CURRENT_EPISODE'
export const PAUSED = 'podcast/PAUSED'
export const STORY_LIST = 'stories/STORY_LIST'
export const CURRENT_STORY = 'stories/CURRENT_STORY'
export const VISIBLE = 'stories/VISIBLE'
export const PLAYING = 'stories/PLAYING'
export const RELEASES = 'stories/RELEASES'

// Mutations
export const MUTATE_UPDATE_CURRENT_EPISODE = 'podcast/MUTATE_UPDATE_CURRENT_EPISODE'
export const PLAY = 'podcast/PLAY'
export const PAUSE = 'podcast/PAUSE'
export const UPDATE_TIME = 'podcast/UPDATE_TIME'
export const UPDATE_DURATION = 'podcast/UPDATE_DURATION'
export const TOGGLE_STORIES = 'stories/TOGGLE_STORIES'
export const SHOW_STORY = 'stories/SHOW_STORY'
export const HIDE_STORY = 'stories/HIDE_STORY'
export const SET_CURRENT_STORY = 'stories/SET_CURRENT_STORY'

// Actions
export const UPDATE_CURRENT_EPISODE = 'podcast/UPDATE_CURRENT_EPISODE'



// WEBPACK FOOTER //
// ./src/store/types.js